const d = [
    {
        type: 'Feature',
        properties: {
            unique_id: '410325107',
            ext_path: '河南省 洛阳市 嵩县 白河镇',
            cid: '1',
            pid: '410325',
            name: '白河镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.943702, 33.649372]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410325103',
            ext_path: '河南省 洛阳市 嵩县 车村镇',
            cid: '2',
            pid: '410325',
            name: '车村镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.092142, 33.774976]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410325100',
            ext_path: '河南省 洛阳市 嵩县 城关镇',
            cid: '3',
            pid: '410325',
            name: '城关镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.986383, 34.201905]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410325201',
            ext_path: '河南省 洛阳市 嵩县 大坪乡',
            cid: '4',
            pid: '410325',
            name: '大坪乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.008822, 34.240847]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410325106',
            ext_path: '河南省 洛阳市 嵩县 大章镇',
            cid: '5',
            pid: '410325',
            name: '大章镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.875099, 34.06239]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410325006',
            ext_path: '河南省 洛阳市 嵩县 德亭镇',
            cid: '6',
            pid: '410325',
            name: '德亭镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.909272, 34.135544]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410325109',
            ext_path: '河南省 洛阳市 嵩县 饭坡镇',
            cid: '7',
            pid: '410325',
            name: '饭坡镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.231839, 34.155248]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410325203',
            ext_path: '河南省 洛阳市 嵩县 何村乡',
            cid: '8',
            pid: '410325',
            name: '何村乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.010031, 34.129718]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410325209',
            ext_path: '河南省 洛阳市 嵩县 黄庄乡',
            cid: '9',
            pid: '410325',
            name: '黄庄乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.243458, 34.048313]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410325010',
            ext_path: '河南省 洛阳市 嵩县 九店乡',
            cid: '10',
            pid: '410325',
            name: '九店乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.308827, 34.185362]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410325102',
            ext_path: '河南省 洛阳市 嵩县 旧县镇',
            cid: '11',
            pid: '410325',
            name: '旧县镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [111.829523, 34.023711]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410325012',
            ext_path: '河南省 洛阳市 嵩县 库区乡',
            cid: '12',
            pid: '410325',
            name: '库区乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.141243, 34.171674]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410325210',
            ext_path: '河南省 洛阳市 嵩县 木植街乡',
            cid: '13',
            pid: '410325',
            name: '木植街乡',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.113829, 33.927393]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410325101',
            ext_path: '河南省 洛阳市 嵩县 田湖镇',
            cid: '14',
            pid: '410325',
            name: '田湖镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.196937, 34.264492]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410325104',
            ext_path: '河南省 洛阳市 嵩县 闫庄镇',
            cid: '15',
            pid: '410325',
            name: '闫庄镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.064753, 34.280374]
        }
    },
    {
        type: 'Feature',
        properties: {
            unique_id: '410325108',
            ext_path: '河南省 洛阳市 嵩县 纸房镇',
            cid: '16',
            pid: '410325',
            name: '纸房镇',
            last_time: '2018-01'
        },
        geometry: {
            type: 'Point',
            coordinates: [112.106818, 34.059185]
        }
    }
];

export { d };
